import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import News from '@/components/News'
import About from '@/components/About'
import ApiInfo from '@/components/ApiInfo'

Vue.use(Router)

export default new Router(
  {
    mode: "history", // Better for SEO
    routes: [
      {
        path: '/',
        name: 'Hem',
        component: Home,
      },
      {
        path: '/news',
        name: 'Nyheter',
        component: News,
      },
      {
        path: '/about',
        name: 'Om oss',
        component: About,
      },
      {
        path: '/api_info',
        name: 'Öppen API',
        component: ApiInfo,
      }
    ]
  },
)
